import { render, staticRenderFns } from "./hot-text-highlight.vue?vue&type=template&id=3e0483ae&scoped=true"
import script from "./hot-text-highlight.ts?vue&type=script&lang=ts&external"
export * from "./hot-text-highlight.ts?vue&type=script&lang=ts&external"
import style0 from "./hot-text-highlight.scss?vue&type=style&index=0&id=3e0483ae&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0483ae",
  null
  
)

export default component.exports